
const MvcStatus = {
    STATUS_DRAFT: 'RAS',
    STATUS_SUBMITTED: 'EMT',
    STATUS_RECEIVED: 'REC',
    STATUS_CANCELLED: 'CAN',
}

export default MvcStatus;